import React from "react";
import { Modal, Button, ModalHeader, ModalBody } from "react-bootstrap";

interface DeleteModalProps {
  show: boolean;
  handleClose: () => void;
  deleteModalFunction: () => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  error?: string | null;
  showIcon?: boolean;
}

export const DeleteModal = ({
  show,
  handleClose,
  deleteModalFunction,
  title = 'Are you sure?',
  message = 'Are you sure you want to delete this item?',
  confirmLabel = 'Yes',
  cancelLabel = 'No',
  isLoading = false,
  error = null,
  showIcon = true,
}: DeleteModalProps) => {
  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={handleClose}
        id="removeCartModal"
        className="fade zoomIn"
        dialogClassName="modal-dialog-centered"
        contentClassName="rounded-4"
      >
        <ModalHeader closeButton></ModalHeader>
        <ModalBody className="p-md-5">
          <div className="text-center">
            {showIcon && (
              <div className="text-danger">
                <i className="bi bi-trash display-5"></i>
              </div>
            )}
            <div className={showIcon ? 'mt-4' : ''}>
              <h4 className="mb-2 fw-bold">{title}</h4>
              <p className="text-secondary mx-4 mb-0" style={{ fontSize: '0.9375rem' }}>{message}</p>
              {error && (
                <div className="alert alert-danger mt-3" role="alert">
                  <i className="ri-error-warning-line me-2"></i>
                  {error}
                </div>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <Button
              type="button"
              variant="outline-secondary"
              className="btn w-sm rounded-3 border"
              onClick={handleClose}
              disabled={isLoading}
            >
              {cancelLabel}
            </Button>
            <Button
              type="button"
              variant="danger"
              className="btn w-sm btn-hover rounded-3"
              id="delete-record"
              onClick={deleteModalFunction}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {confirmLabel}
                </>
              ) : (
                confirmLabel
              )}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export const ConfirmOrder = ({ show, handleClose }: any) => {
    return (
        <React.Fragment>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className="mt-2 text-center">
                        <i className="bi bi-shop display-6"></i>
                        <div className="mt-4 pt-2 mx-4 mx-sm-5">
                            <h4>Confirm your order ?</h4>
                            <p className="text-muted mx-4 mb-0">Are you sure you want to confirm order ?</p>
                        </div>
                    </div>
                    <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <Button type="button" className="btn w-sm btn-ghost-danger" onClick={handleClose}><i className="bi bi-x-lg align-baseline me-1"></i> Close</Button>
                        <Button type="button" variant="success" className="btn w-sm" onClick={handleClose}>Yes, Confirm Order</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}